import React from 'react';
// mui
import { Checkbox, MenuItem } from '@mui/material';

// components
import { withStyles } from '@mui/styles';
import GlobalIndicator from '../../main/common/GlobalIndicatorWrapper';
import ToolTipIcon from '../../../_assets/svg/Tooltip.svg';
import SimpleTooltip from '../../SimpleTooltip';

const styles = () => {
  return {
    togglingContainer: {
      display: 'flex',
      flexDirection: 'row',
      margin: '0 0 0 0.833rem',
      cursor: 'pointer',
    },
    icon: {
      width: '0.833rem',
      height: '0.833rem',
      margin: '0.25rem 0.833rem 0 0',
    },
    text: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.33,
      margin: '0px !important',
    },
  };
};

// @ts-expect-error TS(2345): Argument of type '() => { togglingContainer: { dis... Remove this comment to see the full error message
export const GlobalMenuOption = withStyles(styles)(
  ({ classes, ...props }: any) => {
    const selectedUx = () => {
      return props.selectProps.supportSelectAll ? (
        <section className={classes.togglingContainer}>
          <div
            className={classes.icon}
            style={
              props.isSelected
                ? { backgroundColor: props.data.color }
                : { border: `1px solid ${props.data.color}` }
            }
          />
          {}
          '.
          <p className={classes.text} style={{ color: props.data.color }}>
            {props.children}
          </p>
          {}
          '.
          {props.data.tooltip ? (
            <SimpleTooltip
              title={props.data.tooltip}
              style={{ marginLeft: '0.2rem' }}
            >
              <ToolTipIcon />
            </SimpleTooltip>
          ) : null}
        </section>
      ) : (
        <React.Fragment>
          <Checkbox checked={props.isSelected} color="secondary" />
          {props.children}
        </React.Fragment>
      );
    };

    return (
      <MenuItem
        className={props.selectProps.classes.menuItem}
        buttonRef={props.innerRef}
        selected={props.isFocused}
        component="div"
        style={{
          fontWeight: props.isSelected ? 500 : 400,
        }}
        {...props.innerProps}
      >
        '{}'.
        {props.isMulti ? (
          selectedUx()
        ) : (
          <div
            style={{
              paddingLeft: '0.833rem',
              paddingRight: '0.833rem',
            }}
          >
            <GlobalIndicator
              inline
              isGlobal={props.data.accountBounded}
              text={props.children}
            />
          </div>
        )}
      </MenuItem>
    );
  }
);

export default GlobalMenuOption;
